import React from 'react';
import { Redirect } from 'react-router-dom';
// import AccountForm from '../components/AccountForm';

export default props => (
  <Redirect to="/" />
);